import { defineStore } from "pinia";
import { useI18n } from "vue-i18n";
import { IConfig } from "~/types/config.interface";
import { Brand, Countries, ILocales } from "~/types/entities";

const STORE_NAMESPACE = "config";

export enum UserTypes {
  Companies = "companies",
  Partners = "partners",
  Users = "users",
}

interface UserTypeConfig {
  id: string;
  value: UserTypes;
  path: string;
}

export const userTypes: UserTypeConfig[] = Object.values(UserTypes).map((value) => ({
  id: value,
  value,
  path: `/${value === UserTypes.Companies ? "" : value}`,
}));

export const useConfigStore = defineStore(STORE_NAMESPACE, {
  state: (): IConfig => ({
    system: {
      build: useRuntimeConfig().public.buildNumber as string,
    },
    brand: useRuntimeConfig().public.brand as Brand,
  }),

  getters: {
    countryCode: (): keyof typeof Countries => {
      const { locale, locales } = useI18n<{ locales: ILocales[] }>();
      const currentLocale = locales.value.find(
        (localeItem) => localeItem.code === locale.value
      );
      return currentLocale?.country ?? "default";
    },
    supportsArchivedSubscriptions: (state): boolean => {
      return state.brand === Brand.allsports;
    },
  },
});
